import React from 'react';
import { useIsStandard } from '@contexts/operator/PlanContext';

/**
 * Renders children only when NOT on the standard plan.
 * Use to hide merchant selectors and merchant-scoped UI from standard plan users.
 */
export function HideInStandard({ children }) {
  return useIsStandard() ? null : children;
}

/**
 * Renders children ONLY when on the standard plan.
 * Use for UI that should only appear when the merchant concept is hidden
 * (typically simplified copy or alternative controls for standard-plan UX).
 */
export function OnlyInStandard({ children }) {
  return useIsStandard() ? children : null;
}
